import React, { useState, useEffect } from 'react';

import Breadcrumb from '../../Components/Common/Modules/Breadcrumb';
import LoadingSpinner from '../../Helpers/LoadingSpinner';
import useSuscripcionesConEstado from '../../Hooks/useSuscripcionesConEstado';
import useObtenerDatosCRM from '../../Hooks/useObtenerDatosCRM';
import ErrorBoundary from '../../Components/Common/Organism/ErrorBoundary';
import FormularioSolicitudBaja from '../../Components/Features/MisSuscripciones/FormularioSolicitudBaja';
import { esAptoParaBaja } from '../../Filter/solicitudBaja';
import TitleWeb from '../../Components/Common/Web/Title';

const SolicitudBaja = () => {
    const [suscripciones, errorSuscripciones, isLoadingSuscripciones] = useSuscripcionesConEstado();
    const [cliente, errorCRM, isLoadingCRM, getDataCrm] = useObtenerDatosCRM();
    const [suscripcionesParaBaja, setSuscripcionesParaBaja] = useState([]);

    useEffect(() => {
        getDataCrm();
        const susParaBaja = suscripciones
            ?.map((sus) => {
                if (esAptoParaBaja(sus)) {
                    return sus;
                }
            })
            .filter((sus) => sus !== undefined);
        setSuscripcionesParaBaja(susParaBaja);
    }, [suscripciones]);

    return (
        <>
            <section>
                <Breadcrumb firstItem={'Mis suscripciones'} href={'#'} text={'Solicitud de baja'} />
                <TitleWeb text="Solicitud de baja" />
            </section>
            <section className="container-streched">
                <LoadingSpinner isLoading={isLoadingSuscripciones || isLoadingCRM}>
                    <ErrorBoundary error={errorSuscripciones || errorCRM}>
                        {cliente && cliente.DatosPersonales && (
                            <FormularioSolicitudBaja suscripciones={suscripcionesParaBaja} cliente={cliente.DatosPersonales} />
                        )}
                    </ErrorBoundary>
                </LoadingSpinner>
            </section>
        </>
    );
};

export default SolicitudBaja;
